import React from 'react'
import { RouteObject } from 'react-router-dom'
import { lazyPage, lazyWithSuspense } from '@app/utils/routeUtils'
import { MainLayout } from '@components/layout/MainLayout'
import { AuthGuard } from '@components/guards/AuthGuard'
import { ParameterGuard } from '@shared/components/guards/ParameterGuard'
import { EMkModifyBookStep } from '@features/book/types'

export const accountRoutes: RouteObject[] = [
  {
    path: 'account',
    element: <MainLayout themeSwitcher />,
    children: [
      // Public routes (no auth required)
      {
        path: 'activate',
        element: lazyWithSuspense(() => import('@pages/account/MkPageActivate')),
      },
      {
        path: 'password-reset',
        element: lazyWithSuspense(() => import('@pages/account/MkPageActivate')),
      },
      {
        path: 'login/callback',
        element: lazyWithSuspense(() => import('@auth/components/LoginCallback/LoginCallback').then((module) => ({ default: module.LoginCallback }))),
      },
      {
        path: 'logout/callback',
        element: lazyWithSuspense(() => import('@auth/components/LogoutCallback/LogoutCallback').then((module) => ({ default: module.LogoutCallback }))),
      },
    ],
  },
  // Root account route with promo header
  {
    path: 'account',
    element: (
      <AuthGuard>
        <MainLayout
          themeSwitcher
          promoHeader
        />
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        element: lazyWithSuspense(() => import('@pages/home/MkPageHome')),
        // element: lazyPage('MkAccountDashboard', 'account'),
      },
    ],
  },
  // Other protected account routes (no promo header)
  {
    path: 'account',
    element: (
      <AuthGuard>
        <MainLayout themeSwitcher />
      </AuthGuard>
    ),
    children: [
      // Commented routes below can be uncommented as needed
      {
        path: 'my-trips',
        element: lazyWithSuspense(() => import('@pages/account/MyTrips/MyTripsLayout')),
        children: [
          {
            index: true,
            element: lazyWithSuspense(() => import('@pages/account/MyTrips/MkMyTrips')),
          },
          {
            path: 'waitlist',
            element: lazyWithSuspense(() => import('@pages/account/Waitlist/Waitlist')),
          },
          {
            path: 'waitlist/create',
            element: lazyWithSuspense(() => import('@pages/account/Waitlist/WaitlistCreate')),
          },
          {
            path: ':tripId',
            element: lazyWithSuspense(() => import('@pages/account/TripDetails').then((module) => ({ default: module.TripDetails }))),
          },
          {
            path: ':tripId/modify',
            element: lazyWithSuspense(() => import('@pages/account/ModifyReservation').then((module) => ({ default: module.ModifyReservation }))),
          },
          {
            path: ':tripId/modify/:step',
            element: (
              <ParameterGuard
                parameterName="step"
                validValues={[EMkModifyBookStep.DATES, EMkModifyBookStep.TRAVELER, EMkModifyBookStep.PROTECTION]}>
                {lazyPage('MkPageModifyBook', 'book')}
              </ParameterGuard>
            ),
          },
        ],
      },
      {
        path: 'credits',
        element: lazyWithSuspense(() => import('@pages/account/MkPageCreditSummary')),
        // element: lazyPage('MkPageCreditSummary', 'account/CreditSummary'),
      },
      {
        path: 'dues-loans',
        children: [
          {
            index: true,
            element: lazyWithSuspense(() => import('@pages/account/DuesLoans/MkDuesLoans')),
            // element: lazyPage('MkDuesLoans', 'account/DuesLoans'),
          },
          {
            path: 'payments',
            element: lazyWithSuspense(() => import('@pages/account/DuesLoans/MkPayments')),
            // element: lazyPage('MkPayments', 'account/DuesLoans'),
          },
        ],
      },
      {
        path: 'rci-exchanges',
        element: lazyWithSuspense(() => import('@pages/account/DepositsRCI/MkDepositsRciExchangesRoute')),
      },
      {
        path: 'points-benefits',
        element: lazyWithSuspense(() => import('@pages/account/PointsBenefits')),
        // element: lazyPage('PointsBenefits', 'account'),
      },
      {
        path: 'credits-benefits',
        element: lazyWithSuspense(() => import('@pages/account/PointsBenefits')),
      },
      {
        path: 'deposit-points',
        element: lazyWithSuspense(() => import('@pages/account/DepositsRCI/MkDepositsRCIFlow')),
        // element: lazyPage('MkDepositsRCIFlow', 'account/DepositsRCI'),
      },
      {
        path: 'conversions-rci',
        element: lazyWithSuspense(() => import('@pages/account/DepositsRCI/MkDepositsRCI')),
        // element: lazyPage('MkDepositsRCI', 'account/DepositsRCI'),
      },
      {
        path: 'wishlist',
        element: lazyWithSuspense(() => import('@pages/account/AccountWishlist/MkPageWishlist')),
        // element: lazyPage('MkPageWishlist', 'account/AccountWishlist'),
      },
      {
        path: 'my-account',
        element: lazyWithSuspense(() => import('@pages/account/MyAccount/PageMyAccount')),
        // element: lazyPage('PageMyAccount', 'account/MyAccount'),
      },
    ],
  },
]
